import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Cuánto tiempo necesito?',
    a: '15–30 minutos por sesión. No necesitas un sábado entero.'
  }, {
    q: '¿Funciona si mi ingreso es variable?',
    a: "Sí. El plan se basa en reglas y 'pagos base + pago ataque' ajustable."
  }, {
    q: '¿Y si me da vergüenza mirar mis números?',
    a: "Por eso existe. Empiezas con una 'foto mínima' sin trauma."
  }];
  return <Section background="white" className="pb-12" data-id="element-1">
      <h2 className="text-3xl text-center text-[#2D3B2D] mb-12" data-id="element-2">
        Preguntas Frecuentes
      </h2>
      <div className="grid md:grid-cols-3 gap-8" data-id="element-3">
        {faqs.map((faq, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-[#FAFAF7] p-6 rounded-xl border border-[#E8EDE6]" data-id="element-4">
            <h3 className="font-bold text-[#2D3B2D] mb-3" data-id="element-5">{faq.q}</h3>
            <p className="text-[#4A5D4A] text-sm leading-relaxed" data-id="element-6">{faq.a}</p>
          </motion.div>)}
      </div>

      <div className="mt-8 text-center border-t border-[#E8EDE6] pt-6" data-id="element-7"></div>
    </Section>;
}